export const fundGuideNb = {
    fundGuide: {
        highlighted: {
            title: 'Fremhevede treff',
            selectionLabel: 'Fremhevede treff',
            remove: 'Fjern fondsguidens anbefalinger',
            loading: 'Henter anbefalte fond',
            empty: 'Ingen anbefalte fond er tilgjengelige for valgt betalingstype.',
            errorTitle: 'Vi kunne ikke hente anbefalte fond',
            errorBody: 'Det oppsto en feil da vi hentet anbefalte fond. Prøv igjen.',
            retry: 'Prøv igjen',
        },
        title: 'Finn din fondstype',
        introDescription: 'Få forslag til fondstyper som passer til valgt tidsperiode og hvor mye svingninger du er komfortabel med. Dette er generell veiledning, ikke rådgivning eller en anbefaling.',
        chooseOption: 'Velg',
        savingPeriod: {
            label: 'Spareperiode',
            choices: {
                underTwoYears: 'Under 2 år',
                twoToFiveYears: '2-5 år',
                fivePlusYears: '5+ år',
            },
            infoLabel: 'Om periode',
            infoTitle: 'Om spareperiode',
        },
        riskTolerance: {
            label: 'Risikotoleranse',
            choices: {
                cautious: 'Forsiktig',
                someRisk: 'Tåler noe',
                moreRisk: 'Tåler mer',
            },
            infoLabel: 'Om risiko',
            infoTitle: 'Om risikotoleranse',
        },
        summary: {
            title: 'Forslag til fondstype',
            lessRisk: 'Mindre risiko',
            moreRisk: 'Mer risiko',
            fundTypes: {
                FIXED_INCOME: 'Rentefond',
                BALANCED: 'Kombinasjonsfond',
                EQUITY: 'Aksjefond',
            },
            riskLevels: {
                FIXED_INCOME: 'Lavere risiko',
                BALANCED: 'Middels risiko',
                EQUITY: 'Høyere risiko',
            },
            recommendationLabel: 'Anbefalt fondstype',
            showFunds: 'Se fondene som passer',
            showExplanation: 'Se hvorfor denne fondstypen foreslås',
        },
    },
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibmIuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi8uLi8uLi8uLi9zcmMvc2hhcmVkL3RyYW5zbGF0aW9ucy9mdW5kLWd1aWRlL25iLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUVBLE1BQU0sQ0FBQyxNQUFNLFdBQVcsR0FBOEI7SUFDbEQsU0FBUyxFQUFFO1FBQ1AsV0FBVyxFQUFFO1lBQ1QsS0FBSyxFQUFFLGtCQUFrQjtZQUN6QixjQUFjLEVBQUUsa0JBQWtCO1lBQ2xDLE1BQU0sRUFBRSxpQ0FBaUM7WUFDekMsT0FBTyxFQUFFLHVCQUF1QjtZQUNoQyxLQUFLLEVBQUUsZ0VBQWdFO1lBQ3ZFLFVBQVUsRUFBRSxvQ0FBb0M7WUFDaEQsU0FBUyxFQUFFLDZEQUE2RDtZQUN4RSxLQUFLLEVBQUUsWUFBWTtTQUN0QjtRQUNELEtBQUssRUFBRSxvQkFBb0I7UUFDM0IsZ0JBQWdCLEVBQ1osOEtBQThLO1FBQ2xMLFlBQVksRUFBRSxNQUFNO1FBQ3BCLFlBQVksRUFBRTtZQUNWLEtBQUssRUFBRSxjQUFjO1lBQ3JCLE9BQU8sRUFBRTtnQkFDTCxhQUFhLEVBQUUsWUFBWTtnQkFDM0IsY0FBYyxFQUFFLFFBQVE7Z0JBQ3hCLGFBQWEsRUFBRSxPQUFPO2FBQ3pCO1lBQ0QsU0FBUyxFQUFFLFlBQVk7WUFDdkIsU0FBUyxFQUFFLGlCQUFpQjtTQUMvQjtRQUNELGFBQWEsRUFBRTtZQUNYLEtBQUssRUFBRSxpQkFBaUI7WUFDeEIsT0FBTyxFQUFFO2dCQUNMLFFBQVEsRUFBRSxXQUFXO2dCQUNyQixRQUFRLEVBQUUsV0FBVztnQkFDckIsUUFBUSxFQUFFLFdBQVc7YUFDeEI7WUFDRCxTQUFTLEVBQUUsV0FBVztZQUN0QixTQUFTLEVBQUUsb0JBQW9CO1NBQ2xDO1FBQ0QsT0FBTyxFQUFFO1lBQ0wsS0FBSyxFQUFFLHVCQUF1QjtZQUM5QixRQUFRLEVBQUUsZUFBZTtZQUN6QixRQUFRLEVBQUUsWUFBWTtZQUN0QixTQUFTLEVBQUU7Z0JBQ1AsWUFBWSxFQUFFLFdBQVc7Z0JBQ3pCLFFBQVEsRUFBRSxrQkFBa0I7Z0JBQzVCLE1BQU0sRUFBRSxXQUFXO2FBQ3RCO1lBQ0QsVUFBVSxFQUFFO2dCQUNSLFlBQVksRUFBRSxlQUFlO2dCQUM3QixRQUFRLEVBQUUsZ0JBQWdCO2dCQUMxQixNQUFNLEVBQUUsZUFBZTthQUMxQjtZQUNELG1CQUFtQixFQUFFLG9CQUFvQjtZQUN6QyxTQUFTLEVBQUUsdUJBQXVCO1lBQ2xDLGVBQWUsRUFBRSxzQ0FBc0M7U0FDMUQ7S0FDSjtDQUNKLENBQUMifQ==